import React, { useContext, useEffect, useRef, useState } from 'react';
import Button from './Button';
import classNames from 'classnames';
import TextInput from './TextInput';
import CloseIcon from '../../../assests/img/close.svg?react';
import {FilterContext} from '../context/filterContext';
import {checkNull} from '../functions/utils';

export interface addUnderwriterProps {
    currentData: any
    underwriterData: (data: any)=> void
    onClose: ()=> void,
}

export default function AddUnderwriter(props: addUnderwriterProps) {

    const {onClose, underwriterData, currentData} = props;
    
    const dropdownRef = useRef<HTMLDivElement>(null);
    const {filterData} = useContext(FilterContext);

    const newUnderwriterInitialData = {
        id: '0',
        name: '',
        title: '',
        phone: '',
        mobile: '',
        department: '',
        email: '',
        submissionEmail: '',
        address: '',
        coverageId: '0',
    }
    
    const [showContacts, setShowContacts] = useState(false);
    const [newUnderwriter, setNewUnderwriter] = useState<{
        id: string,
        name: string,
        title: string,
        phone: string,
        mobile: string,
        department: string,
        email: string,
        submissionEmail: string,
        address: string,
        coverageId: string,
    }>(newUnderwriterInitialData);
    const [contactsList, setContactList] = useState(() =>
            filterData.contacts
                        .filter((data: any) => data.name && data.name.trim() !== "")
                        .sort((a: any, b: any) => a.name.localeCompare(b.name))
        );

    const style = {
        borderRadius: '8px',
        fontSize: '14px',
        fontFamily: 'inter',
        fontWeight: '500',
    }

    const underwriterFields = [
        {
            id: 'name',
            title: 'Name',
            placeholder: 'Enter Name Here',
            width: '100%',
        },
        {
            id: 'title',
            title: 'Title',
            placeholder: 'Enter Title Here',
            width: '100%',
        },
        {
            id: 'phone',
            title: 'Telephone',
            placeholder: 'Enter Telephone Here',
            width: '100%',
        },
        {
            id: 'mobile',
            title: 'Mobile',
            placeholder: 'Enter Mobile Here',
            width: '100%',
        },
        {
            id: 'department',
            title: 'Department',
            placeholder: 'Enter Department Here',
            width: '200%',
        },
        {
            id: 'email',
            title: 'Email',
            placeholder: 'Enter Email Here',
            width: '100%',
        },
        {
            id: 'submissionEmail',
            title: 'Submission Email',
            placeholder: 'Enter Submission Email Here',
            width: '100%',
        },
        {
            id: 'address',
            title: 'Address',
            placeholder: 'Enter Address Here',
            width: '200%',
        }
    ]

    const handleUnderwriterData = (field: string, value: string) => {
        setNewUnderwriter({...newUnderwriter, [field]: value});
    }

    const filterContacts = (text: string) => {
  setNewUnderwriter({ ...newUnderwriter, name: text });

  if (text.length) {
    const temp: any = filterData.contacts
      .filter(
        (data: any) =>
          data.name &&
          data.name.trim() !== "" &&
          data.name.toLowerCase().includes(text.toLowerCase())
      )
      .sort((a: any, b: any) => a.name.localeCompare(b.name)); 
    setContactList(temp);
    setShowContacts(temp.length > 0);
  } else {
    setContactList([]);
    setShowContacts(false);
  }
};

    const handleUnderwriterDataInput = () => {
        underwriterData(newUnderwriter);
        onClose();
    }

    const selectedContact = (id: number) => {
        const contact: any = filterData.contacts.filter((data: any)=>
            data.id === id);
        if (contact.length) {
            const temp = {
                id: id.toString(),
                name: checkNull(contact[0].name, 'string'),
                title: checkNull(contact[0].title, 'string'),
                department: checkNull(contact[0].department, 'string'),
                email: checkNull(contact[0].email, 'string'),
                phone: checkNull(contact[0].phone, 'string'),
                mobile: checkNull(contact[0].mobile, 'string'),
                address: checkNull(contact[0].address, 'string'),
                submissionEmail: checkNull(contact[0].submissionEmail, 'string'),
                coverageId: checkNull(contact[0].coverage, 'string'),
            };
            setNewUnderwriter(temp);
            setShowContacts(false);
        }
    }

    const handleClickOutside=(event: MouseEvent)=> {
        if (dropdownRef.current &&
            !dropdownRef.current.contains(event.target as Node)) {
            setShowContacts(false);
        }
    }

    useEffect(()=> {
        setNewUnderwriter(currentData);
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    },[]);

    return (
        <div>
            <div className="add-edit-underwriter-container">
                <span className="underwriter-close-btn">
                    <CloseIcon className="edit-icon underwriter-close-icon"
                    onClick={onClose}/></span>
                <div className="underwriter-header-container">
                    <div className="underwriter-heading">
                        Add underwriter</div>
                    <div className="underwriter-controls">
                        <div className="underwriter-action-btn">
                            <div>
                                <Button buttonText='Back' onClick={onClose}
                                    type='primary-outline'
                                    customClassName='underwriter-primary-btn'/>
                            </div>
                            <div>
                                <Button buttonText='Add'
                                    onClick={handleUnderwriterDataInput} type='primary' customClassName='underwriter-primary-btn'/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="add-edit-underwriter-content">
                    {underwriterFields.map((field, index)=> {
                        return (
                            <div key={`ur-${field.id}-${index}`}
                                className={classNames('underwriter-field',
                                    field.width === '200%'? 'full-width': '')}>
                                <div className="underwriter-field-title">{field.title}</div>
                                {field.id === 'name'?
                                    <div className="contact-list-add"
                                        ref={dropdownRef}
                                        onFocus={()=> setShowContacts(true)}>
                                        <TextInput type='text'
                                            style={{width: field.width,
                                                ...style}}
                                            placeholder={field.placeholder}
                                            text={newUnderwriter[
                                                field.id as keyof
                                                typeof newUnderwriter]}
                                            onChange={(text)=>
                                                filterContacts(text)}/>
                                        {showContacts?
                                        <div className="contact-list-dropdown">
                                        {contactsList.map((data: any, index)=> {
                                            return (
                                                <div 
                                                    key={`contact-add-
                                                        ${data.id}-${index}`}
                                                    className="contact-list-item"
                                                    onClick={()=>
                                                        selectedContact(
                                                            data.id)}>
                                                    {data.name}
                                                </div>
                                            )
                                        })}</div>: null}
                                    </div>:
                                <div> <TextInput type='text'
                                    style={{width: field.width, ...style}}
                                    placeholder={field.placeholder}
                                    text={newUnderwriter[field.id as keyof
                                        typeof newUnderwriter]}
                                    onChange={(text)=>
                                        handleUnderwriterData(field.id, text)}/>
                                </div>}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );

}